import { MessageCircle } from "lucide-react";

const Footer = () => (
  <footer className="border-t border-white/10 bg-black/40 py-16" data-testid="footer">
    <div className="mx-auto flex max-w-7xl flex-col gap-10 px-6 md:flex-row md:items-end md:justify-between md:px-12">
      <div>
        <img src="/assets/logo-meli.webp" alt="Meli Market Minds" className="h-10 w-auto mix-blend-screen" />
        <p className="mt-4 max-w-md font-editorial text-xl italic leading-relaxed text-lilac/80">
          “No se trata solamente de aprender neuromarketing. Se trata de empezar a entender
          tu marca desde la perspectiva de la persona que tiene que elegirte.”
        </p>
      </div>
      <div className="text-xs uppercase tracking-[0.25em] text-lilac/50">
        <p>Meli Market Minds · eye square Latinoamérica</p>
        <p className="mt-2">Método CEREBRO · Agosto · GMT-3</p>
        <a
          href="https://wa.me/595976724321?text=Hola%20Meli"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-whatsapp-link"
          className="mt-4 inline-flex items-center gap-2 text-neoncyan transition-colors duration-300 hover:text-magenta"
        >
          <MessageCircle className="h-3.5 w-3.5" /> WhatsApp +595 976 724 321
        </a>
        <a
          href="/admin"
          data-testid="footer-admin-link"
          className="mt-3 block text-[10px] text-lilac/30 transition-colors duration-300 hover:text-magenta"
        >
          Acceso admin
        </a>
      </div>
    </div>
  </footer>
);

export default Footer;
